import React from "react";
import style from "../../Styles/Components/Roulette.module.css";
import styled, { keyframes } from "styled-components";
import $ from "jquery";
import * as Const from "../../Data/const";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";
// import rotate from "./jquery.rotate.js";
//component
// import  from "./";

class Roulette extends React.Component {
  constructor() {
    super();
    this.state = {
        rouletteAnim: null,
        currentDeg: 0,
        rouletteData: [],
        isStart: false,

        logEvent: {},

        breakpointStart: 0, // 당첨된 상품 룰렛 시작 각도
        breakEndPoint: 0, // 당첨된 상품 룰렛 끝 각도
    };

    this.animationTime = 8000;

    this.startRoulette = this.startRoulette.bind(this);
    this.calcRotate = this.calcRotate.bind(this);
  }

  
  get spin(){
      const fromDeg = this.state.currentDeg % 360;
      // -35 ~ 35, 37 ~ 107,     -36, 36 36 ~ 108
      const toDeg = fromDeg + this.random(this.state.breakpointStart + 1, this.state.breakpointEnd);
      this.setState({
          currentDeg: toDeg % 360
      })
      return keyframes`
        from {
          transform: rotate(${fromDeg}deg);
        }
      
        to {
          transform: rotate(${toDeg}deg);
        }
      `;
  }

  startRoulette(){
      let isLogin = this.props.checkIsLogin();
      console.log('로그인했나요?', isLogin);
      if (!isLogin) {
          return;
      } else {
          if (this.state.isStart) return;


          this.calcRotate(this.props.eventPrize).then((res) => {
              console.log(this.state);
              this.setState({
                  rouletteAnim: this.spin,
                  isStart: true,
              }, () => {
                  this.props.eventSubmit();
                  setTimeout(() => {
                      if (this.props.handleResultModal) {
                          this.props.handleResultModal();
                      }
                  }, this.animationTime);
              })
          }).catch((err) => {
              console.log(err);
              let errData = Const.getError(err.response.data);

              if (errData.code == 'MSG_USER_IS_ALREADY_JOIN_EVENT') {
                  this.setState({
                      showIsPrized: true,
                  });
              } else {
                  Const.showAlert('', errData.errorMessage);
              }
          })
      }
  }

  calcRotate(eventPrize) {
      // 멈출 지점 계산용
      return new Promise((resolve) => {
          let prizedEventPrize = eventPrize;

          let eventPrizeList = this.props.localEvent.eventPrize

          console.log(eventPrizeList, prizedEventPrize);

          let prizeIndex = eventPrizeList.findIndex((item) => {
              return JSON.stringify(item) == JSON.stringify(prizedEventPrize);
          });

          console.log(prizeIndex);
          console.log(eventPrizeList);

          let breakpointEnd = this.state.currentDeg + (360/eventPrizeList.length) * prizeIndex;
          let breakpointStart = breakpointEnd - (360/eventPrizeList.length);
          this.setState({
              breakpointStart: breakpointStart,
              breakpointEnd: breakpointEnd
          }, () => {
            console.log(this.state)
            resolve(true);
          })
      })
  }

  componentDidMount() {
    this.setState({
      rouletteData: this.rouletteData
    }, ()=>{
      console.log(this.state.rouletteData);
      this.setState({
        currentDeg: 180/this.state.rouletteData.length
      })
    })
  }

  random(min, max) {
      console.log(min, max)
      min = Math.ceil(min);
      max = Math.floor(max);

      const debugRandom = Math.random() * (max - min) + min;
      console.log(debugRandom)
      return (Math.random() * (max - min) + min) + 7200;
  }

  render() {
    return (
      <div className={style.container}>
        <img className={style.markers} src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/img-roulette.svg"}></img>
        <div className={style.boxRoulette} id="boxRoulette">
            {
              this.state.isStart ?
                  <button type="button" className={style.button + ' ' + style.stop} id="btnStart" onClick={this.startRoulette}>
                    <div className={style.buttonCircle}>
                        <div className={style.buttonText1}>돌려라 룰렛</div>
                        <div className={style.buttonText2}>STOP</div>
                    </div>
                  </button> :
                  <button type="button" className={style.button} id="btnStop" onClick={this.startRoulette}>
                    <div className={style.buttonCircle}>
                    <div className={style.buttonText1}>돌려라 룰렛</div>
                    <div className={style.buttonText2}>START</div>
                    </div>
                  </button>
            }
          <RouletteCircle id="roulette" animation={this.state.rouletteAnim} rouletteSize={this.rouletteList.length} backgroundGradient={this.rouletteBackground}>
            {this.rouletteList}
          </RouletteCircle>
        </div>
      </div>
    );
  }

  get rouletteData(){
    let { localEvent, t } = this.props;
  console.log(localEvent.eventPrize);
    if (!localEvent.eventPrize || localEvent.eventPrize.length == 0) {
      alert(Const.MESSAGE_TABLE[this.props.COUNTRY_CODE].EVENT_NOT_EXISTS);
      return;
    }

    return localEvent.eventPrize.map((item) => {
      return {
          type: item.EPrizeType,
          topContent: item.EPrizeType === 'image' ? item.image : item.name,
          bottomContent: item.EPrizeType === 'image' ? item.detail :
              (item.EPrizeType === 'void' ? t('lotto_void_message') : item.detail)
      }
    })
  }
  
  get rouletteBackground(){
    const rouletteSize = this.rouletteList.length
    const deg = 360 / rouletteSize;
    const colorList = [];

    for(let i = 1; i <= rouletteSize ; i++){
      i !== 1 && colorList.push(",")

      if((rouletteSize === 5 || rouletteSize === 3) && i === 1){
        colorList.push(`#d5cfd8 0 ${deg*i}deg`)
      }else if(i % 2){
        colorList.push(`#f0eef1 0 ${deg*i}deg`)
      }else{
        colorList.push(`#fefefe 0 ${deg*i}deg`)
      }
    }
    return colorList.join("");
  }

  get rouletteList(){
    return this.state.rouletteData && this.state.rouletteData.map((item, index, list)=> {
      //const deg = (360/list.length) * index + 180/list.length
      const deg = (360 - (360/list.length) / 2) - (360/list.length) * index
      return item.type === "text" ? <RouletteItem deg={deg} key={index}>
        <RouletteContent>
          <div className={style.topContent}>{item.topContent}</div>
          <div className={style.bottomContent} style={{marginTop: 0}} dangerouslySetInnerHTML={ {__html: item.bottomContent} }></div>
        </RouletteContent>
      </RouletteItem>
      : item.type === "image" ? <RouletteItem deg={deg} key={index}>
        <RouletteContent>
          <div className={style.topContent}><img src={item.topContent} className={style.image}/></div>
          <div className={style.bottomContent}>{item.bottomContent}</div>
        </RouletteContent>
      </RouletteItem>
      : item.type === "void" ? <RouletteItem deg={deg} key={index}>
        <RouletteContent>
          <div className={style.topContent}><FailText>{item.topContent}</FailText></div>
          <div className={style.bottomContent}>{item.bottomContent}</div>
        </RouletteContent>
      </RouletteItem>
      : {}
    })
  }
}

const RouletteCircle = styled.div`
  position:relative;
  width:100%;
  height:100%;
    max-width: 360px;
  max-height: 360px;
  overflow:hidden;
  transform: rotate(${(props)=> 180 / props.rouletteSize}deg);
  animation: ${(props)=>props.animation} 7s cubic-bezier(.25,.1,.25,1) forwards;
  background-image: conic-gradient(${(props)=>props.backgroundGradient});
`

const RouletteItem = styled.div`
  position:absolute;
  height: 90vw;
  width: 90vw;
  max-width: 360px;
  max-height: 360px;
  transform: rotate(${(props)=>props.deg}deg);
`

const RouletteContent = styled.div`
  margin-top: 20px;
`

const FailText = styled.span`
  color: #dc3e32;
  font-size: 24px;
`
export default connect((state) => {
    return {
        eSESSION: state.data.eSESSION.eSESSION,
        COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE
    }
})(withRouter(withTranslation()(Roulette)))
